// extracted by mini-css-extract-plugin
export default {"nav_container":"Navigation_nav_container__Gy96L","icon":"Navigation_icon__sGu5R","active":"Navigation_active__1vK5v"};